import { render } from "./FireSidebar.vue?vue&type=template&id=388bc3de&scoped=true"
import script from "./FireSidebar.vue?vue&type=script&lang=ts"
export * from "./FireSidebar.vue?vue&type=script&lang=ts"

import "./FireSidebar.vue?vue&type=style&index=0&id=388bc3de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-388bc3de"

export default script